exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-90eaccae]  .dialog_box{border-radius:10px}.box[data-v-90eaccae]  .dialog_box .el-dialog__header{border-radius:10px 10px 0 0;background:#ecf4ff;color:#282828;font-weight:600;font-size:22px}.box .from_box[data-v-90eaccae]{padding:0 80px}", ""]);

// exports
